module.exports = {
    master : require('./master'),
    slave : require('./slave')
};